import HeroImage from "../../components/heros/hero-image";
import imgConsultancy from "../../assets/images/consultancy-hero.jpeg";
import ConsultancyOurServices from "./components/consultancy-our-services/consultancy-our-services";
import ConsultancyOffer from "./components/consultancy-offer/consultancy-offer";
import ConsultancyCompetence from "./components/consultancy-competence/consultancy-competence";
import ConsultancyProcess from "./components/consultancy-process/consultancy-prosess";

import { MAILTO_COMMERCIAL, TEL_SEGRETERIA } from "../../constants/contacts";
import { useBreakpoint } from "../../hooks/useBreakpoint";

import "./consultancy.scss";

const Consultancy: React.FC = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile";
  return (
    <div className="consultancy">
      <HeroImage
        serviceText="SERVIZIO POFESSIONALE"
        serviceIcon="clipboard"
        certificationTitle="Esperienza"
        certificationText="+20 Anni"
        certificationIcon="shield"
        title="Dalla Progettazione alla Realizzazione"
        text="Con o senza progetto, ti guidiamo fino alla realizzazione dell'opera."
        img={imgConsultancy}
        altImg="header img"
        isMobile={isMobile}
        btnLeftText="Chiamaci ora"
        btnLeftIconName="phone"
        btnRightText="Invia Email"
        btnRightIconName="envelope"
        btnLeftHref={TEL_SEGRETERIA}
        btnRightHref={MAILTO_COMMERCIAL}
      />
      <ConsultancyOurServices />
      <ConsultancyOffer />
      <ConsultancyCompetence />
      <ConsultancyProcess />
    </div>
  );
};

export default Consultancy;
